import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.EQUIPMENT_PHOTOS].GET_PHOTOS]: {
		url: '/company/:companyId/equipment/:equipmentId/photos/',
	},
	[ModulesConfigMap[ModulesMap.EQUIPMENT_PHOTOS].GET_PHOTO]: {
		url: '/company/:companyId/equipment/:equipmentId/photos/:photoId',
	},
	[ModulesConfigMap[ModulesMap.EQUIPMENT_PHOTOS].CREATE_PHOTO]: {
		url: '/company/:companyId/equipment/:equipmentId/photos/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.EQUIPMENT_PHOTOS].PUT_PHOTO]: {
		url: '/company/:companyId/equipment/:equipmentId/photos/',
		requestOptions: {
			method: 'PUT',
		},
	},
	[ModulesConfigMap[ModulesMap.EQUIPMENT_PHOTOS].PATCH_PHOTO]: {
		url: '/company/:companyId/equipment/:equipmentId/photos/:photoId',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.EQUIPMENT_PHOTOS].DELETE_PHOTO]: {
		url: '/company/:companyId/equipment/:equipmentId/photos/:photoId',
		requestOptions: {
			method: 'DELETE',
		},
	},
}
